import { useMutation } from "@apollo/client/react";
import { FiGlobe, FiLock } from "react-icons/fi";
import {
  AccessLevel,
  UpdateMediaAccessLevelDocument,
  type UpdateMediaAccessLevelMutation,
  type UpdateMediaAccessLevelMutationVariables,
} from "../../../generated/graphql";
import type { MediaItem } from "../types";

interface AccessLevelToggleProps {
  media: MediaItem;
}

export function AccessLevelToggle({ media }: AccessLevelToggleProps) {
  const [updateAccess, { loading }] = useMutation<
    UpdateMediaAccessLevelMutation,
    UpdateMediaAccessLevelMutationVariables
  >(UpdateMediaAccessLevelDocument);

  const setAccessLevel = (level: AccessLevel) => {
    if (media.accessLevel === level) return;
    updateAccess({
      variables: {
        id: media.id,
        accessLevel: level,
      },
    });
  };

  const isPrivate = media.accessLevel === AccessLevel.Private;

  return (
    <div className="flex flex-col gap-0.5">
      {/* Public option */}
      <button
        type="button"
        onClick={() => setAccessLevel(AccessLevel.Public)}
        disabled={loading}
        className={`flex items-center gap-1 text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
          !isPrivate ? "text-gray-900 font-medium" : "text-gray-400 hover:text-gray-600"
        }`}
        title="Set to public"
      >
        <FiGlobe className="h-3 w-3" />
        <span>Public</span>
      </button>

      {/* Private option */}
      <button
        type="button"
        onClick={() => setAccessLevel(AccessLevel.Private)}
        disabled={loading}
        className={`flex items-center gap-1 text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
          isPrivate ? "text-gray-900 font-medium" : "text-gray-400 hover:text-gray-600"
        }`}
        title="Set to private"
      >
        <FiLock className="h-3 w-3" />
        <span>Private</span>
      </button>
    </div>
  );
}
